import { decodeHtml } from '@/utils/decodeHtml';
import parser from 'html-react-parser';
import { createElement } from 'react';

export function toHtmlNode(str: string) {
  return createElement('div', null, parser(decodeHtml(str)));
}
